// docs: https://github.com/altostra/type-validations#readme
import { anyOf, arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { nullValidation, number, string } from "@altostra/type-validations/lib/primitives";

import type { DalleAssistantAsyncResult } from "./types";

const dalleGeneratedImage = objectOf({
  image_token: string,
  preview_url: string,
});
const nullableImages = anyOf(arrayOf(dalleGeneratedImage), nullValidation);
const nullableString = anyOf(string, nullValidation);

export const isDalleAssistantAsyncResult = objectOf<DalleAssistantAsyncResult>({
  status: number,
  response: maybe(nullableImages),
  error: maybe(nullableString),
  error_code: maybe(string),
});
